import { Alt, Shift, Control } from "../Index";
export function toModifierArray(props) {
    const modifiers = [];
    if (props.alt) {
        modifiers.push(Alt);
    }
    if (props.shift) {
        modifiers.push(Shift);
    }
    if (props.control) {
        modifiers.push(Control);
    }
    return modifiers;
}
